import { NotificationPill } from '.';
import { ProfileIcon } from '../../../../../assets/svg/home-notifications/ProfileIcon';

interface EmailNotificationPillProps {
  onClick: () => void;
}

export const EmailNotificationPill = ({ onClick }: EmailNotificationPillProps) => {
  return (
    <NotificationPill
      notification={{
        icon: <ProfileIcon />,
        titleIntlId: `drivers.home_notification.profile.missing_email.title`,
        messageIntlId: `drivers.home_notification.profile.missing_email.message`,
        onClick,
      }}
    />
  );
};
